import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'reactstrap';

import QuestionsDisplay from 'components/questions/display/QuestionsDisplay';
import CategoryListing from 'components/questions/display/QuestionsCategory';
import SurveyTemplateApi from 'apis/SurveyTemplate';
import Toaster from 'components/Toaster';

import Loading from 'utils/Loading';
import 'assets/scss/questions.css';

class Questions extends Component {
  constructor() {
    super();
    this.state = {
      questions: [],
      categories: [],
      loaded: false,
      name: '',
    };
    this.fetchDetails = this.fetchDetails.bind(this);
    this.fetchCategories = this.fetchCategories.bind(this);
    this.saveQuestionOrder = this.saveQuestionOrder.bind(this);
    this.setOrderedQuestions = this.setOrderedQuestions.bind(this);
    this.setName = this.setName.bind(this);
  }

  componentWillMount() {
    this.fetchCategories();
    this.fetchDetails();
  }

  componentDidUpdate(prevProps) {
    const { location } = this.props;

    if (location !== prevProps.location) {
      this.fetchDetails();
    }
  }

  fetchDetails() {
    const { match } = this.props;
    const { id } = match.params;
    if (id) {
      SurveyTemplateApi.getDetails(id)
        .then(({ data }) => {
          this.setState({ name: data.name, questions: data.survey_template_questions });
        })
        .catch(e => console.log(e));
    }
  }

  fetchCategories() {
    SurveyTemplateApi.getAll()
      .then(({ data }) => {
        this.setState({ categories: data, loaded: true });
      })
      .catch(e => console.log(e));
  }

  setName(name) {
    this.setState({ name });
  }

  setOrderedQuestions = questions => {
    const question_order = questions.map(question => question.id);

    this.setState({ questions, question_order });
  };

  saveQuestionOrder() {
    const { question_order } = this.state;
    const questionOrder = { question_order };
    const { match } = this.props;

    SurveyTemplateApi.update(match.params.id, questionOrder)
      .then(() => {
        this.fetchCategories();
        Toaster.getSuccessToaster('check-circle', 'Question arranged successfully');
      })
      .catch(error => {
        console.log(error);
        Toaster.getFailureToaster(error, 'exclamation-triangle', 'Something went wrong');
      });
  }

  render() {
    const { loaded, questions, name, categories } = this.state;
    const { match } = this.props;
    const categoryId = match.params.id;
    const initialDisplay = categoryId ? (
      <QuestionsDisplay
        categoryId={categoryId}
        fetchDetails={this.fetchDetails}
        setOrderedQuestions={this.setOrderedQuestions}
        questions={questions}
        saveQuestionOrder={this.saveQuestionOrder}
      />
    ) : (
        <div className="question-welcome">Choose a category to display or add questions</div>
      );
    if (!loaded) {
      return <Loading />;
    }
    return (
      <div className="container">
        <h2 className="mt-4 mb-4 text-truncate">{name}</h2>
        <Row>
          <Col xs="3">
            <CategoryListing
              categoryId={categoryId}
              categories={categories}
              setName={this.setName}
            />
          </Col>
          <Col xs="9">{initialDisplay}</Col>
        </Row>
      </div>
    );
  }
}

Questions.propTypes = {
  match: PropTypes.shape({}).isRequired,
};

export default Questions;



// WEBPACK FOOTER //
// ./src/containers/Questions.js